import { render, staticRenderFns } from "./SupplierManage.vue?vue&type=template&id=b3ac9f12&scoped=true"
import script from "./SupplierManage.vue?vue&type=script&lang=js"
export * from "./SupplierManage.vue?vue&type=script&lang=js"
import style0 from "./SupplierManage.vue?vue&type=style&index=0&id=b3ac9f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ac9f12",
  null
  
)

export default component.exports